import {
  Button,
  Checkbox,
  Slider,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  setRef,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

import { useEffect, useState, useRef, useContext } from "react";
import GetWithin from "../utils/GetWithin";
import { useLocalStorage } from "../utils/LocalStorageHook";
import TableAbstraction from "../componentUtils/TableAbstraction";
import GetBanked from "../utils/GetBank";
import PostBank from "../utils/PostBank";
import { DisplayRoleContext } from "src/Context_api";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bankError: {
      padding: theme.spacing(2),
    },
    checkbox: {
      margin: 0,
      padding: 0,
    },
    slider: {
      width: "400px",
    },
    route: {
      padding: theme.spacing(2),
    },
    submit: {
      margin: theme.spacing(2),
    },
    bankTextField: {
      width: "200px",
    },
  })
);

interface BankInput {
  customerNum: string;
  postBankChanges: any;
  bankCustomer: any;
  setBankCustomer: any;
  isChanged: boolean;
  saveCustomerDetails: any;
  setWarningPopUp: any;
  setBackdropLoader: any;
  openBankNameDialog: boolean;
  setOpenBankNameDialog: any;
}

export default function BankPage(props: BankInput) {
  const classes = useStyles();
  const [miles, setMiles] = useState(0.25);
  const [changed, setChanged] = useState(true);
  const [state, setState] = useState<any>();
  const [bankInfo, setBankInfo] = useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [selected, setSelected] = useState<any[]>([]);
  const [bankName, setBankName] = useState<string>("");
  const [saveBtnVisible, setSaveBtnVisible] = useState<boolean>(false);
  const [bankUpdates, setBankUpdates] = useState<any>();
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>("");
  const [warningPop, setWarningPop] = useState<boolean>(false);
  const {isDisplayOnlyRole}: any = useContext(DisplayRoleContext);

  useEffect(() => {
    if (!changed) return;
    GetBanked(salesOrg, props.customerNum)
      .then((v: any) => setBankInfo(v))
      .catch((_) => setBankInfo("Failed to find bank information."))
      .then((_) =>
        GetWithin(salesOrg, props.customerNum, miles)
          .then((v: any) => {
            setChanged(false);
            setState(v);
          })
          .catch((_) => setState("Failed to find customers."))
      );
  }, [state, miles]);
  const { bankCustomer } = props;
  useEffect(() => {
    if (state) {
      const customerDetails = state?.filter((q: any) => props.bankCustomer.includes(q.customer_num));
      props.saveCustomerDetails(customerDetails);
    }
  }, [bankCustomer]);
  useEffect(() => {
    if (bankInfo && bankInfo.bank && bankInfo.bank.mdBankCustomers) {
      const bankCustArr: any[] = bankInfo.bank.mdBankCustomers.map((x: any) => x.customerNum);
      if (!bankCustArr.includes(props.customerNum)) {
        bankCustArr.unshift(props.customerNum);
        props.setBankCustomer(bankCustArr);
      } else {
        props.setBankCustomer(bankCustArr);
      }
    } else {
      const customerNum = [props.customerNum];
      props.setBankCustomer(customerNum);
    }
  }, [bankInfo]);

  useEffect(() => {
    if (bankName === "") {
      setHelperText("Bank name may not be empty.");
      setError(true);
    } else if (bankName?.length >= 0 && bankName?.length < 3) {
      setHelperText("Bank name must be atleast 3 characters.");
      setError(true);
    } else if (bankName?.length > 20) {
      setHelperText("Bank name should not exceed 20 characters.");
      setError(true);
    } else {
      setHelperText("");
      setError(false);
    }
  }, [bankName]);

  if (!state || typeof state === "string") return <Typography className={classes.bankError}>{state}</Typography>;

  // const bankedCust =
  // (bankInfo &&
  //   bankInfo.bank &&
  //   bankInfo.bank.mdBankCustomers.map((x: any) => x.customerNum)) ||
  //   [];

  const handleSubmit = () => {
    // if (!selected || selected.length < 1) return;
    if (props.bankCustomer?.length === 0) {
      props.setWarningPopUp(true);
    } else {
      const selectedCus = state.filter((q: any) => props.bankCustomer.includes(q.customer_num));
      //console.log("::::selectedCus",selectedCus)
      let guid = "";
      let name = "";

      if (bankInfo && bankInfo.bank) {
        guid = bankInfo.bank.guid;
        name = bankInfo.bank.bankName;
      }

      const obj: any = {
        clientId: "100",
        salesOrg,
        salesOffice: selectedCus[0].sales_office,
        plant:selectedCus[0].delivering_plant,
        bankName: bankName || name,
        mdBankCustomers: selectedCus.map((c: any) => ({
          ...c,
          salesOffice: c.sales_office,
          customerNum: c.customer_num,
        })),
      };

      if (guid) obj.guid = guid;
      const bankUpdate = obj;
      if (selectedCus.length >= 2) {
        if (obj.bankName === "") {
          setBankUpdates(obj);
          props.setOpenBankNameDialog(true);
        } else {
          props.postBankChanges(salesOrg, bankUpdate);
        }
      } else {
        setWarningPop(true);
      }
    }
  };

  const bankText = (bankInfo && bankInfo.bank && bankInfo.bank.bankName) || bankName || "";

  const handleCheckbox = (value: string) => {
    if (value !== props.customerNum) {
      if (props.bankCustomer.indexOf(value) === -1) {
        const newBankedCust: Array<string> = props.bankCustomer;
        newBankedCust.push(value);
        props.setBankCustomer(newBankedCust);
      } else {
        const newBankedCust: Array<string> = props.bankCustomer.filter((val: string) => val !== value);
        props.setBankCustomer(newBankedCust);
      }
      setSaveBtnVisible(true);
      const customerDetails = state.filter((q: any) => props.bankCustomer.includes(q.customer_num));

      props.saveCustomerDetails(customerDetails);
    }
  };
  const handleBankNameSave = () => {
    if (bankUpdates) {
      bankUpdates.bankName = bankName;
      props.setOpenBankNameDialog(false);
      props.setBackdropLoader(true);
      props.postBankChanges(bankUpdates.salesOrg, bankUpdates);
    } else {
      const selectedCus = state.filter((q: any) => props.bankCustomer.includes(q.customer_num));
     // console.log("::::selectedCus",selectedCus)
      let guid = "";
      let name = "";
      if (bankInfo && bankInfo.bank) {
        guid = bankInfo.bank.guid;
        name = bankInfo.bank.bankName;
      }
      const obj: any = {
        clientId: "100",
        salesOrg,
        salesOffice: selectedCus[0].sales_office,
        plant: selectedCus[0].delivering_plant,
        bankName: bankName || name,
        mdBankCustomers: selectedCus.map((c: any) => ({
          ...c,
          salesOffice: c.sales_office,
          customerNum: c.customer_num,
        })),
      };

      if (guid) obj.guid = guid;
      props.postBankChanges(salesOrg, obj);
    }
  };
  return (
    <div className={classes?.route}>
      {(!state[0]?.latitude || !state[0]?.longitude) && (
        <Typography>Warning: Latitude or Longitude may be incorrect.</Typography>
      )}
      {props.bankCustomer.length < 1 && (
        <Typography>Warning: No banked customers found. You may create a new one.</Typography>
      )}
      <Typography id="discrete-slider-small-steps" gutterBottom>
        Distance ({miles} Miles)
      </Typography>
      <div className={classes.slider}>
        <Slider
          defaultValue={1}
          aria-labelledby="discrete-slider-small-steps"
          step={0.25}
          marks
          min={0.25}
          max={10}
          value={miles}
          onChange={(_, value) => {
            if (value == miles) return;
            setChanged(true);
            setMiles(value as number);
          }}
          onChangeCommitted={(_, value) => {
            setChanged(true);
            setMiles(value as number);
          }}
          valueLabelDisplay="auto"
        />
      </div>
      {selected.length > 0 && (
        <form noValidate autoComplete="off">
          <TextField
            helperText={"Bank name may not be empty."}
            label="Bank Name"
            value={bankName}
            defaultValue={bankInfo && bankInfo.bank && bankInfo.bank.bankName}
            onChange={(v: any) => setBankName(v.target.value)}
          />
          <Button variant="contained" color="primary" className={classes.submit} onClick={handleSubmit}>
            Submit Request
          </Button>
        </form>
      )}
      {
        <Dialog
          fullWidth
          maxWidth="sm"
          open={props.openBankNameDialog}
          // onClose={handleBankNameDialogClose}
        >
          <DialogContent>
            <TextField
              className={classes.bankTextField}
              autoFocus
              margin="dense"
              id="name"
              label="Bank Name"
              type="text"
              fullWidth
              value={bankName}
              onChange={(v: any) => setBankName(v.target.value)}
              variant="standard"
              placeholder="Please enter the Bank Name"
              helperText={helperText}
              error={error}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setBankName("");
                props.setOpenBankNameDialog(false);
              }}
            >
              Cancel
            </Button>
            <Button disabled={error} onClick={handleBankNameSave}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      }
      <TableAbstraction
        settingsKey="BNK_SEL"
        title="Nearby Customers"
        options={{
          elevation: 0,
          selectableRows: "multiple",
          onRowSelectionChange: (currentRows, allRows) => {
            setSelected(allRows);
          },
          rowsPerPage: 25,
          rowsPerPageOptions: [25, 50, 100],
        }}
        columns={[
          {
            label: "Customer No",
            name: "custNo",
          },
          {
            label: "Customer Name",
            name: "name1",
          },
          {
            label: "Location",
            name: "location",
            options: {
              renderCell: (params) => {
                const obj = params.row;
                return [obj.street, obj.city, obj.state].filter((v: string) => v.length > 0).join(", ");
              },
            },
          },

          {
            label: "Route",
            name: "master_route",
          },
          {
            label: "Sales Office",
            name: "sales_office",
          },
          {
            label: "Delivery Plant",
            name: "delivering_plant",
          },
          {
            label: "Distance",
            name: "distance",
            options: {
              customBodyRender: (value, tableMeta) => value && (value as number).toFixed(2) + " miles",
            },
          },
          {
            label: "Banked",
            name: "",
            valueGetter: (params) =>  (props.bankCustomer.length > 0 && props.bankCustomer.indexOf(params.row.customer_num) !== -1),
            options: {
              renderCell: (params: any) => {
                const item = params.row;
                return (<Checkbox disabled={isDisplayOnlyRole}
                  checked={props.bankCustomer.length > 0 && props.bankCustomer.indexOf(item.customer_num) !== -1}
                  name="active"
                  color="primary"
                  className={classes.checkbox}
                  onChange={() => handleCheckbox(item.customer_num)}
                />);
              },
            },
          },
        ]}
        data={state}
        handleSaveProps={{ handleSave: handleSubmit, visible: saveBtnVisible || props.isChanged, isDisplayOnlyRole }}
      />
      <Dialog open={warningPop} onClose={() => setWarningPop(false)}>
        <DialogTitle>Please include at least two bank customers when creating the bank.</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
             PLease try again  
            </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWarningPop(false);
            }}
            color="primary"
          >
            Okay
          </Button>

          {/* <Button onClick={()=>{setConfirmpop(false);}} color="primary" autoFocus>
              No
            </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
